import { Suspense } from "react";
import { RouterProvider } from "react-router";
import router from "@/routes/router";
import FullScreenLoading from "@/components/FullScreenLoading";
import MUIProvider from "@/provider/MUIProvider";
import { ThemeProvider } from "@trimble/modus-cmx";

function App() {
  return (
    <Suspense fallback={<FullScreenLoading />}>
      <ThemeProvider initialTheme={{ theme: "modus-modern", mode: "light" }}>
        <MUIProvider>
          <RouterProvider router={router} />
        </MUIProvider>
      </ThemeProvider>
    </Suspense>
  );
}

export default App;
